import type { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import {
  MOBILE_MAX,
  TABLET_MAX,
  mediaHelper,
  paletteHelper,
  spacingHelper,
} from '@property.com.au/ui-kit';
import { isHopefullyDomEnvironment } from '../../../../../helpers/IsHopefullyDomEnvironment';
import { DefineAdSlot } from '../../../../../app-kit/components/DefineAdSlot/DefineAdSlot';
import { mapSlotConfigFromVariant } from './helpers/mapSlotConfigFromVariant';
import { usePropertyPageQuery } from '../../../../graphql/usePropertyPageQuery';

const adHeightPx = 100;

const mobileAdCss = css`
  height: calc(${adHeightPx}px + ${spacingHelper('medium')} * 2);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${paletteHelper('borderPrimary')};
  flex-shrink: 0;
  flex-grow: 0;
`;

const minHeightPx = 650;
const AdvertisementContainer = styled.div`
  display: none;

  ${mediaHelper('mobile')} {
    ${mobileAdCss}
  }

  @media (min-width: ${MOBILE_MAX +
    1}px) and (max-width: ${TABLET_MAX}px) and (min-height: ${minHeightPx}px) {
    ${mobileAdCss}
  }
`;

export const MediaGalleryMobileAd: FunctionComponent = () => {
  const propertyPageBySlugData = usePropertyPageQuery()?.data?.propertyPageBySlugV3;
  const mobileAd = propertyPageBySlugData?.mediaGalleryV2?.mobileAd;

  if (
    !mobileAd ||
    !isHopefullyDomEnvironment() ||
    window.innerWidth > TABLET_MAX ||
    (window.innerHeight < minHeightPx && window.innerWidth > MOBILE_MAX)
  ) {
    return null;
  }

  return (
    <AdvertisementContainer data-testid="MediaGalleryMobileAd">
      <DefineAdSlot slotConfig={mapSlotConfigFromVariant(mobileAd.variant)} />
    </AdvertisementContainer>
  );
};
